/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refresh_ResultsInputs */



/**
* | output |
* | --- |
* | "Refresh Results" |
*
* @param {Refresh_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const refresh_results = /** @type {((inputs?: Refresh_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refresh_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser les résultats")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergebnisse aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna i risultati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить результаты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar resultados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("結果を更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिणाम रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar resultados")
	return /** @type {LocalizedString} */ ("Refresh Results")
});